import { PagedSearch } from '../../shared/model/index';

export class CommunicationRecordSearch extends PagedSearch {
  public MessageId: number = 0;
}
